import React, { useState, useEffect, use } from 'react';
import ReactModal from 'react-modal';
import { ImboxModalContent } from './ImboxModalContent';
import useWasParms from '../../../../Hooks/useWasParms';
import useAppContext from '../../../../Hooks/useAppContext';
import { useImbox } from './ImboxContext';
import * as styles from './ImboxModalStyles.module.scss';

export function ShowImboxModal(props) {
  const { showImboxModal, setShowImboxModal } = useImbox();
  const { addToBagEvent } = useImbox();
  const { imboxBaseCharge } = useWasParms();
  const { passedAppFunctions } = useAppContext();
  const baseCharge = imboxBaseCharge || '7.00';

  const handleClose = () => {
    if (addToBagEvent) {
      props.passedFunctions.ajaxAddToBag(addToBagEvent);
    }
    setShowImboxModal(false);
  };
  const handleAdd = () => {
    if (addToBagEvent) {
      addToBagEvent.imbox = 'true';
      props.passedFunctions.ajaxAddToBag(addToBagEvent);
    }
    setShowImboxModal(false);
  };

  return (
    <ReactModal
      id='imboxModal'
      className={passedAppFunctions.quickviewIsOpen ? styles.imboxModalOverlayQvOpen : styles.imboxModalOverlay}
      overlayClassName={passedAppFunctions.quickviewIsOpen ? styles.imboxModalOverlayQvOpen : styles.imboxModalOverlay}
      isOpen={showImboxModal}
      onRequestClose={handleAdd}
      shouldCloseOnOverlayClick={true}
    >
      <ImboxModalContent baseCharge={baseCharge} onAdd={handleAdd} onDecline={handleClose} onClose={handleClose} />
    </ReactModal>
  );
}
